import { HttpClient, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Tso, FilterClause, PrecedenceGroup } from 'ts-odata';

export abstract class ApiBase {

    get apiUrl(): string {
        return `${environment.apiUrl}/${this.apiCrl}`;
    }

    constructor(private http: HttpClient, private apiCrl: string) { }

    doGet(endpoint: string, options?): Observable<any> {
        return this.http.get(`${this.apiUrl}/${endpoint}`, options);
    }

    doPost(endpoint: string, data, options?): Observable<any> {
        return this.http.post(`${this.apiUrl}/${endpoint}`, data, options);
    }

    doPut(endpoint: string, data, options?): Observable<any> {
        return this.http.put(`${this.apiUrl}/${endpoint}`, data, options);
    }

    doDelete(endpoint: string, options?): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${endpoint}`, options);
    }

    get(id: number): Observable<any> {
        return this.doGet(`${id}`);
    }

    delete(id: number | string): Observable<boolean> {
        return this.doDelete(`${id}`);
    }

    add(item: any): Observable<any> {
        return this.doPost('', item);
    }

    update(item: any): Observable<any> {
        return this.doPut(`${item.Id}`, item);
    }

    createQuery(): Tso {
        return new Tso("buscar");
    }

    odataQuery(query: Tso, onlyActives: boolean = true,) {

        let queryPreparada = this.preparaOdataQuery(onlyActives, query);
        return this.doGet(queryPreparada, { observe: 'response' });
    }

    protected preparaOdataQuery(onlyActives: boolean, query: Tso) {
        if (onlyActives) {
            let activeGroup = new PrecedenceGroup(new FilterClause("Ativo").eq(true));
            query.filter(activeGroup);
        }

        const q = query.toString();
        let qPreparado = q.replace(/'(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z)'/g, '$1');
        return qPreparado;
    }

    doPostFile(endpoint: string, file: File, options?,withProgress=true): Observable<any> {
        const formData: FormData = new FormData();

        formData.append('file', file);

        const req = new HttpRequest('POST', `${this.apiUrl}/${endpoint}`, formData, {
            reportProgress: withProgress,
            responseType: 'json'
        });

        return this.http.request(req);
    }
}
